<template>
  <div class="side-menu">
    <el-menu :router="true" :default-active="$route.path" @open="navigateDefault">
      <div v-for="(mi, idx) in menu">
        <el-menu-item :index="'/'+(mi.path || mi.name.toLowerCase())" v-if="!mi.submenu">
          <i class="fa" :class="[mi.icon]" aria-hidden="true"></i>
          {{ mi.name }}
        </el-menu-item>
        <el-submenu :index="mi.path" v-else>
          <template slot="title"><i class="fa" :class="[mi.icon]"></i> {{ mi.name }}</template>
          <el-menu-item v-for="smi in mi.submenu" :index="smi.path" :key="smi.name">
            <i class="fa" :class="[smi.icon]" aria-hidden="true" v-if="smi.icon"></i> {{ smi.name }}
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<style lang="scss">
.side-menu .el-menu {
  border: none;

  i[class^=fa] {
    margin-right: 10px;
  }
}
</style>

<script>
var menu = [
  { name: 'Dashboard', icon: 'fa-tachometer' },
  { name: 'News',
    icon: 'fa-newspaper-o',
    path: '/news',
    submenu: [
      { name: 'Published', path: '/news', icon: 'fa-paper-plane-o' },
      { name: 'Drafts', path: '/news/drafts', icon: 'fa-pencil-square-o' },
      { name: 'Add New', path: '/news/add', icon: 'fa-plus' }
    ]
  },
  {
    name: 'Suggestions', icon: 'fa-star-o'
  },
  {
    name: 'Vouchers', icon: 'fa-gift'
  },
  { name: 'Users',
    icon: 'fa-users',
    path: '/users',
    submenu: [
      { name: 'Accounts', path: '/users', icon: 'fa-address-card-o' },
      { name: 'Blacklist', path: '/users/blacklist', icon: 'fa-bomb' },
      { name: 'Followees', path: '/users/followees', icon: 'fa-binoculars' }
    ]
  },
  { name: 'Moderation', icon: 'fa-ban' },
  { name: 'API Logs', path: 'apilogs', icon: 'fa-line-chart' },
  { name: 'Servers', icon: 'fa-server' },
  { name: 'Logout', icon: 'fa-sign-out' }
]

export default {
  data () {
    return {
      menu: menu
    }
  },
  methods: {
    navigateDefault (path) {
      if (!this.$route.path.startsWith(path)) {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/SideMenu.vue